import React from 'react'
import { reduxForm } from 'redux-form/dist/redux-form'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { bindAll, partial } from 'lodash-es'

import { track } from '../../../../utils/analytics'
import {
  AjaxButtonComponent,
  Button as ButtonComponent,
} from '../../../../components'
import { SpeakerFormContainerComponent } from '../index'

import './CRUDContainerComponent.scss'

const formName = 'speakersCrudForm'

const getButtonLoadingProps = (text) => ({
  okText: text,
  loadingText: text,
  successText: text,
})

const getButton = (props, text) => (
  <ButtonComponent outlined {...props}>
    {text}
  </ButtonComponent>
)
const renderChancelButton = (onClick) =>
  getButton({ color: 'grey', onClick }, 'Cancel')
const renderDeleteButton = (onClick) =>
  getButton({ color: 'red', onClick }, 'Delete')
const renderSendInviteButton = (onClick, isSent) =>
  getButton({ color: 'grey', onClick }, `${isSent ? 'Resend' : 'Send'} Invite`)

const getPrimaryButton = (okButtonState, valid, text) => (
  <AjaxButtonComponent
    key="submit"
    type="submit"
    state={okButtonState}
    disabled={!valid}
    {...getButtonLoadingProps(text)}
  >
    {text}
  </AjaxButtonComponent>
)

class CRUDContainerComponent extends React.Component {
  constructor() {
    super()

    this.state = { isAddSpeakerCheckboxChecked: false }
    bindAll(this, 'handleSubmit', 'handleCheckboxChange', 'handleSegmentEvents')
  }

  handleSubmit(e) {
    const { onSubmit, mode } = this.props
    e.preventDefault()

    onSubmit(mode, 'add-speaker')
    if (mode === 'new' || mode === 'edit') this.handleSegmentEvents()
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  handleCheckboxChange() {
    this.setState((state) => ({
      isAddSpeakerCheckboxChecked: !state.isAddSpeakerCheckboxChecked,
    }))
  }

  handleSegmentEvents() {
    const { mode, dirty } = this.props
    if (mode === 'new')
      track('Added Webinar Speaker', {
        product: 'WebinarManagement',
      })
    else if (mode === 'edit' && dirty)
      track('Edited Webinar Speaker information', {
        product: 'WebinarManagement',
      })
  }

  render() {
    const {
      valid,
      isVisible,
      mode,
      onCancel,
      addCancelButton,
      change,
      openCrudModal,
      isSendInviteButtonVisible,
      sendInvite,
      crudSpeakerId,
      isCrudSpeakerInviteSent,
      okButtonState,
    } = this.props

    const renderPrimaryButton = partial(getPrimaryButton, okButtonState, valid)

    return (
      <div className="crud-container-component">
        <form onSubmit={this.handleSubmit}>
          <h2 className="crud-header">
            {mode === 'edit' ? (
              <FormattedMessage defaultMessage="Change Speaker Details" />
            ) : (
              <FormattedMessage defaultMessage="Add Speaker" />
            )}
          </h2>
          <SpeakerFormContainerComponent
            mode={mode}
            modalVisible={isVisible}
            change={change}
            formName={formName}
          />
          <div className="crud-footer">
            {mode === 'edit' && (
              <>
                <div className="delete-button-wrapper">
                  {renderDeleteButton(() =>
                    openCrudModal('delete', crudSpeakerId)
                  )}
                </div>
                {isSendInviteButtonVisible && (
                  <div className="send-invite-button-wrapper">
                    {renderSendInviteButton(() => {
                      sendInvite(crudSpeakerId)
                      if (isCrudSpeakerInviteSent) {
                        track('Clicked Resend Invite', {
                          product: 'WebinarManagement',
                        })
                      } else {
                        track('Clicked Send Invite', {
                          product: 'WebinarManagement',
                          context: 'from-edit-speaker',
                        })
                      }
                    }, isCrudSpeakerInviteSent)}
                  </div>
                )}
              </>
            )}
            {addCancelButton && renderChancelButton(onCancel)}
            {renderPrimaryButton(
              mode === 'edit' ? 'Save Changes' : 'Add Speaker'
            )}
          </div>
        </form>
      </div>
    )
  }
}

CRUDContainerComponent.propTypes = {
  mode: PropTypes.oneOf([
    'new',
    'speaker-added',
    'invitation-sent',
    'edit',
    'delete',
  ]),
  okButtonState: PropTypes.oneOf(['idle', 'loading', 'success', 'failure']),
  isVisible: PropTypes.bool,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  openCrudModal: PropTypes.func,
  addCancelButton: PropTypes.bool,
  isSendInviteButtonVisible: PropTypes.bool,
  sendInvite: PropTypes.func,
  crudSpeakerId: PropTypes.string,
  isCrudSpeakerInviteSent: PropTypes.bool,
  // redux form props
  change: PropTypes.func,
  valid: PropTypes.bool,
  dirty: PropTypes.bool,
}

CRUDContainerComponent.defaultProps = {
  addCancelButton: false,
  okButtonState: 'idle',
}

export default reduxForm({ form: formName })(CRUDContainerComponent)
export { CRUDContainerComponent }
